// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"601c0eae","588":"105a3b69"}[chunkId] + ".chunk.js";
};